<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

<h5>玩卦</h5>

目前這裡只有「周易」，是讓您與 64 卦互動的地方。按下任何一卦，其本卦、綜卦、錯卦、互卦、交卦、及其所有卦中卦，會全部展現出來，方便您做全局觀。
點擊任何一個爻名，就會有承乘應與等資料呈現。點擊任何一個爻的圖象，該爻就成了動爻（會由黑變成淡紫色），而宜變之爻也會自動產生（會變成紅色），
並出現第一、第二之卦。

<!-- 將來，我還準備陸續增加幾個助人學易的遊戲。目前還在計畫中。 -->

{:else }

<h5>玩卦</h5>

目前这里只有「周易」，是让您与 64 卦互动的地方。按下任何一卦，其本卦、综卦、错卦、互卦、交卦、及其所有卦中卦，会全部展现出来，方便您做全局观。
点击任何一个爻名，就会有承乘应与等资料呈现。点击任何一个爻的图象，该爻就成了动爻（会由黑变成淡紫色），而宜变之爻也会自动产生（会变成红色），
并出现第一、第二之卦。

<!-- 将来，我还准备陆续增加几个助人学易的游戏。目前还在计划中。 -->

{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
</style>
